const routes = []

/* ------------- Import module routes here -------------- */
import dashboardRoutes from 'Modules/Dashboard/resources/routes'
import aclRoutes from 'Modules/ACL/resources/routes'
import currencyRoutes from 'Modules/Currency/resources/routes'
import regionRoutes from 'Modules/Region/resources/routes'
import userRoutes from 'Modules/User/resources/routes'
import authRoutes from 'Modules/Auth/resources/routes'
import alertRoutes from 'Modules/Alert/resources/routes'
import pairRoutes from 'Modules/Pair/resources/routes'
import operatorRoutes from 'Modules/Operator/resources/routes'
import recipientRoutes from 'Modules/Recipient/resources/routes'
import bankRoutes from 'Modules/Bank/resources/routes'
import transferRoutes from 'Modules/Transfer/resources/routes'
import rebitAccountRoutes from 'Modules/RebitAccount/resources/routes'
import transactionRoutes from 'Modules/Transaction/resources/routes'
import exchangeRoutes from 'Modules/Exchange/resources/routes'
import tradeRoutes from 'Modules/Trade/resources/routes'
import rampRoutes from 'Modules/Ramp/resources/routes'
import paymentMethodRoutes from 'Modules/PaymentMethod/resources/routes'
import notificationRoutes from 'Modules/Notification/resources/routes'
import verificationTypeRoutes from 'Modules/VerificationType/resources/routes'
import helpRoutes from 'Modules/Help/resources/routes'
import affiliateRoutes from 'Modules/Affiliate/resources/routes'
import testimonialRoutes from 'Modules/Testimonial/resources/routes'
import settingRoutes from 'Modules/Setting/resources/routes'

routes.push(...dashboardRoutes)
routes.push(...aclRoutes)
routes.push(...currencyRoutes)
routes.push(...regionRoutes)
routes.push(...userRoutes)
routes.push(...authRoutes)
routes.push(...helpRoutes)
routes.push(...alertRoutes)
routes.push(...pairRoutes)
routes.push(...operatorRoutes)
routes.push(...recipientRoutes)
routes.push(...bankRoutes)
routes.push(...transferRoutes)
routes.push(...rebitAccountRoutes)
routes.push(...transactionRoutes)
routes.push(...exchangeRoutes)
routes.push(...tradeRoutes)
routes.push(...rampRoutes)
routes.push(...paymentMethodRoutes)
routes.push(...notificationRoutes)
routes.push(...verificationTypeRoutes)
routes.push(...affiliateRoutes)

routes.push(...testimonialRoutes)
routes.push(...settingRoutes)

routes.push(
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:notFound(.*)',
    component: () => import('pages/Error404.vue'),
    meta: { isPublicRoute: true }
  }
)
/* ------------------------------------------------------ */

export default routes
